module.exports = __webpack_public_path__ + "img/BRPS-NL.c83d1ea0.png";